import { getOperationAST } from 'graphql';
import isPromise from 'is-promise';
import DataLoader from 'dataloader';
import { memoize2of3 } from './memoize';
import { mergeExecutionParams } from './mergeExecutionParams';
import { splitResult } from './splitResult';
export const getBatchingExecutor = memoize2of3(function (_context, endpoint, executor) {
    var _a, _b, _c;
    const loader = new DataLoader(createLoadFn(executor !== null && executor !== void 0 ? executor : endpoint.executor, (_b = (_a = endpoint.batchingOptions) === null || _a === void 0 ? void 0 : _a.extensionsReducer) !== null && _b !== void 0 ? _b : defaultExtensionsReducer), (_c = endpoint.batchingOptions) === null || _c === void 0 ? void 0 : _c.dataLoaderOptions);
    return (executionParams) => loader.load(executionParams);
});
function createLoadFn(executor, extensionsReducer) {
    return async (execs) => {
        const execBatches = [];
        let index = 0;
        const exec = execs[index];
        let currentBatch = [exec];
        execBatches.push(currentBatch);
        const operationType = getOperationAST(exec.document, undefined).operation;
        while (++index < execs.length) {
            const currentOperationType = getOperationAST(execs[index].document, undefined).operation;
            if (operationType === currentOperationType) {
                currentBatch.push(execs[index]);
            }
            else {
                currentBatch = [execs[index]];
                execBatches.push(currentBatch);
            }
        }
        let containsPromises = false;
        const executionResults = [];
        execBatches.forEach(execBatch => {
            const mergedExecutionParams = mergeExecutionParams(execBatch, extensionsReducer);
            const executionResult = executor(mergedExecutionParams);
            if (isPromise(executionResult)) {
                containsPromises = true;
            }
            executionResults.push(executionResult);
        });
        if (containsPromises) {
            return Promise.all(executionResults).then(resultBatches => {
                let results = [];
                resultBatches.forEach((resultBatch, index) => {
                    results = results.concat(splitResult(resultBatch, execBatches[index].length));
                });
                return results;
            });
        }
        let results = [];
        executionResults.forEach((resultBatch, index) => {
            results = results.concat(splitResult(resultBatch, execBatches[index].length));
        });
        return results;
    };
}
function defaultExtensionsReducer(mergedExtensions, executionParams) {
    const newExtensions = executionParams.extensions;
    if (newExtensions != null) {
        Object.assign(mergedExtensions, newExtensions);
    }
    return mergedExtensions;
}
//# sourceMappingURL=getBatchingExecutor.js.map